import React from 'react';

type IconProps = React.HTMLAttributes<HTMLElement> & {
    className?: string; // optional additional CSS classes
    size?: 'sm' | 'lg' | '2x' | '3x' | '4x' | '5x';
};

const iconMap = {
    EasyUpdate: 'fal fa-edit',
    Edit: 'fal fa-pen',
    SameCaseGroup: 'fal fa-layer-group',
    CaseHistory: 'fal fa-history'
} as const;

const icons = Object.fromEntries(
    Object.entries(iconMap).map(([name, baseClasses]) => [
        `Checkmate${name}Icon`,
        ({ size, className, ...props }: IconProps) => {
            const faSize = size ? `fa-${size}` : '';
            const classes = [baseClasses, faSize, className].filter(Boolean).join(' ');
            return <i className={classes} {...props} />;
        },
    ])
) as Record<string, React.FC<IconProps>>;

export const { CheckmateEasyUpdateIcon, CheckmateEditIcon, CheckmateSameCaseGroupIcon, CheckmateCaseHistoryIcon } = icons;
